import { Step } from "react-joyride";

export const tourStepsTimedChallenges = (): Step[] => {
  const steps: Step[] = [
    {
      target: "h1.mb-8",
      content:
        "Timed Challenges is a one-minute fluency drill. The goal is to identify 60 items in 60 seconds.",
      disableBeacon: true,
    },
    {
      target: ".game-instructions",
      content:
        "You need a collection first. If this list is empty, create one on Your Collections, then come back.",
    },
    {
      target: ".collections-overview",
      content:
        "Click a collection to select it. That set of items will flash during the challenge.",
    },
    {
      target: ".start-button",
      content:
        "Start the timer, then tap Got it when you know the item, or Skip to move on. Space or Enter is Got it. X is Skip.",
    },
  ];

  return steps;
};
